
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns58ae7b64db500942d1409d9bc0c82889en from './en.yaml'
            i18n.addResourceBundle('en', '58ae7b64db500942d1409d9bc0c82889', flattenObject(ns58ae7b64db500942d1409d9bc0c82889en), true, true);
        
        export default '58ae7b64db500942d1409d9bc0c82889';
    